import { createContext, useContext, useEffect, useState, useCallback, useRef } from "react";
import { api, apiErr } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const IDLE_MS = 30 * 60 * 1000; // 30分無操作で自動ログアウト

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=確認中, false=未ログイン, object=ログイン済
  const idleTimer = useRef(null);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("wcc_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("wcc_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("wcc_token");
    setUser(false);
  }, []);

  // 無操作自動ログアウト
  useEffect(() => {
    if (!user) return;
    const reset = () => {
      if (idleTimer.current) clearTimeout(idleTimer.current);
      idleTimer.current = setTimeout(() => { logout(); }, IDLE_MS);
    };
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((e) => window.addEventListener(e, reset));
    reset();
    return () => { events.forEach((e) => window.removeEventListener(e, reset)); if (idleTimer.current) clearTimeout(idleTimer.current); };
  }, [user, logout]);

  const login = async (login_id, password) => {
    try {
      const { data } = await api.post("/auth/login", { login_id, password });
      localStorage.setItem("wcc_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiErr(e, "ログインに失敗しました") };
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}
